export default __webpack_public_path__ + "static/media/Close_small_white.cb4e3e01.svg";